import "./Profile.css";
import tempStat from "../../assets/Group 1.png";
import Share from "../components/share/Share";
import Galloria from "../components/gallery/Gallery";
import { useContext, useEffect, useState } from "react";
import { HiOutlineUserAdd } from 'react-icons/hi'
import { AiOutlineMessage } from 'react-icons/ai'
import AuthContext from "../../context/AuthProvider";
import { Link, useLocation } from "react-router-dom";
import { axiosInstance } from "../../config.util";

export default function Profile() {
  const {authState: user} = useContext(AuthContext);
  const getParams = useLocation();
  const [getUserData, setUserData] = useState({})
  const [searchedUser, setsearchedUser] = useState([]);
  const location = useLocation();

  const { searchUsrId } = location.state;

  const isAppUser = getParams.pathname.substring(getParams.pathname.lastIndexOf('/')+1);

  useEffect(()=>{
    const getpost = async ()=>{
      // api/users/623ca97dbae45693f15b788c
      const userData = await axiosInstance.get("/users/"+user.id, {
        headers: {
          "Authorization": `Bearer ${user.accessToken}`,
        },
      });
      setUserData(userData.data)
    }
    const fetchUsers = async()=>{
      const res = await axiosInstance.get(`/users/${searchUsrId}`)
      setsearchedUser(res.data);
    }
    fetchUsers();
    getpost()
  },[searchUsrId, user.accessToken, user.id])

  const onClickFollowUsr = async ()=>{
    await axiosInstance(`/users/${searchUsrId}/follow`,{
      method: 'PUT',
      headers: {
        "Authorization": `Bearer ${user.accessToken}`,
        'content-type': 'application/json',
      },
      data: {userId: user.id}
    }).then(response=>{
      // console.log('SUCCESS');
    }).catch(err=>{
      // console.log('ERROR:(')
    })
  }

  const onClickUnFollowUsr = async ()=>{
    await axiosInstance(`/users/${searchUsrId}/unfollow`,{
      method: 'PUT',
      headers: {
        "Authorization": `Bearer ${user.accessToken}`,
        'content-type': 'application/json',
      },
      data: {userId: user.id}
    }).then(response=>{
      // console.log('SUCCESS');
    }).catch(err=>{
      // console.log('ERROR:(')
    })
  }

  // console.log('from profile page: user and isAppuserm, searchedUser', user, isAppUser, searchedUser);
  return (
    <div className="profile__container viewp">
      <div className="hz__slider">
        <div className="gallery">
          <Galloria />
        </div>
      </div>
      <div className="profile">
        <div className="profile__img">
          <img src={user.user === isAppUser?user.avatar:searchedUser.avatar} alt="profile" />
        </div>
        {/* <!--TODO need to handle fix height --> */}
        <div className="profile__desc">
          <div className="profile__desc-top">
            <h1 className="profile__username">@{isAppUser}</h1>
            <div className="profile__follow-or-edit">
              <div className="follow-or-edit">
                {user.user === isAppUser?'Edit Profile':(
                  <div className="userprofile__follow_unfollow">
                    <button className="profile__follow-user" onClick={onClickFollowUsr}>
                      Follow
                    </button>
                    <button className="profile__unfollow-user" onClick={onClickUnFollowUsr}>
                      Unfollow
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="profile__dt-icons">
                {isAppUser === (user.user) ? null : 
                <Link to={'/message'}>
                  <AiOutlineMessage className="pro__dt-icon profile_user-message" />
                </Link>
                }
            </div>
          </div>
          <div className="profile__desc-mid">
            <div className="p_dm-nest profile__user-followes">
              <span className="user_pfc prof__count-folr">
                {/* GET FOLLOWER LENGTH */}
                {getUserData && getUserData.followers && getUserData.followers.length > 0 ? getUserData.followers.length:'0'}
              </span><span className="block_con">followers</span></div>
            <div className="p_dm-nest profile__user-following">
              <span className="user_pfc prof__count-folg">
                {/* GET FOLLOWING LENGTH */}
                {getUserData && getUserData.followings && getUserData.followings.length > 0 ? getUserData.followers.length:'0'}
              </span><span className="block_con">followings</span></div>
          </div>
          <div className="profile__desc-botm">
            <div className="pdb__wrapper">
              <div className="pdb__w-style profile__skill">{
                isAppUser === (user.user)?getUserData.skill:searchedUser.skill
              }</div>
              <div className="pdb__w-style--bgt profile__email">{
                isAppUser === (user.user)?getUserData.email:searchedUser.email
              }</div>
            </div>
            <div className="pdb-dec__wrapper">
              <p className="profile__user-bio">{
                isAppUser === (user.user)?getUserData.desc:searchedUser.desc
              }</p>
            </div>
          </div>
        </div>

      </div>
      <div className="stats__container">
        <img src={tempStat} alt="" className="tracker" />
        <div className="tracker-chart">
          
        </div>

      </div>
      <div className="p__share">
        <Share/>
      </div>
    </div>
  );
}
